<template>
  <md-input
      v-model="modelValue"
      v-on="$listeners"
      @keypress="onKeypress"
      @paste.prevent
      :maxlength="maxlength"
      :type="inputType"
      :class="showNumberArrow?'':'hide-arrow'"
  />
</template>

<script lang="js">
export default {
  name: "NewNumberWings",
  props: {
    value: String,
    maxlength: String,
    withMinusNum: {
      type: Boolean,
      require: false,
      default: false
    },
    inputType: {
      type: String,
      require: false,
      default: 'number'
    },
    showNumberArrow: {
      type: Boolean,
      require: false,
      default: true
    }
  },
  data() {
    return {
      count: 1,
      invalidChars: ["e", "+", "E"]
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    onKeypress($event) {
      if (this.withMinusNum) {
        if (this.invalidChars.includes($event.key)) {
          $event.preventDefault();
        }
      } else {
        if (/[^\d]/g.test($event.key)) {
          $event.preventDefault();
        }
      }
    },
  },
};
</script>

<style>
/*
Убирание стрелок у input'a (number)
Chrome, Safari, Edge, Opera */
input.hide-arrow::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input.hide-arrow[type=number] {
  -moz-appearance: textfield;
}
</style>
